import Glide from '@glidejs/glide'

export const Offers = () => {
  const $carousel = document.querySelector('.glide.glide-offers')
  if (!$carousel) return

  const OffersCarousel = new Glide($carousel, {
    autoplay: 4000,
    focusAt: 0,
    hoverpause: true,
    gap: 20,
    perView: 4,
    type: 'carousel',
    breakpoints: {
      1023: {
        perView: 3
      },
      767: {
        perView: 2
      },
      599: {
        perView: 1
      }
    }
  }).mount()
}

export const Gallery = () => {
  const $carousel = document.querySelector('.glide.glide-expo--mobile')
  const $carouselDesktop = document.querySelector('.glide.glide-expo--desktop')

  if (!$carousel && !$carouselDesktop) return

  const GalleryCarousel = new Glide($carousel, {
    autoplay: 4000,
    focusAt: 0,
    hoverpause: true,
    gap: 20,
    perView: 1,
    type: 'slider'
  }).mount()

  const GalleryDesktopCarousel = new Glide($carouselDesktop, {
    autoplay: 4000,
    focusAt: 0,
    hoverpause: true,
    gap: 20,
    perView: 1,
    type: 'slider'
  }).mount()
}

export const Banners = () => {
  const $carousel = document.querySelector('.glide-banners')
  if(!$carousel) return

  let total = $carousel.getAttribute('data-total')
  let perView1023 = 5;

  if (total > 7) {
    total = 7;
  }

  if (total == 4) {
    total = 5;
  }

  if (total == 6) {
    total = 7;
  }

  const GalleryCarousel = new Glide($carousel, {
    autoplay: 4000,
    focusAt: 'center',
    hoverpause: true,
    perView: total,
    type: 'carousel',
    breakpoints: {
      1023: {
        perView: 5
      },
      767: {
        perView: 3
      },
      479: {
        perView: 2
      }
    }
  }).mount()
}
